<template>
	<div>
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item :to="{ path: '/setting/customer' }">{{ $t("customerPhone.myClient") }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("customerPhone.customerBinding") }}</el-breadcrumb-item>
		</el-breadcrumb>
		<div>
			<el-button size="mini" style="float: right" @click="handleBindPhone()">{{ $t("customerPhone.addBinding") }}</el-button>
		</div>

		<el-table ref="phonesTable" :data="phonesData" style="width: 100%" :empty-text="$t('customerPhone.noData')" v-loading="loading">
			<!-- <el-table-column prop="phone_number" :label="$t('customerPhone.telephoneNumber')" :formatter="handleTablePhone" width="170"></el-table-column> -->
			<el-table-column prop="phone_number" :label="$t('customerPhone.telephoneNumber')" :formatter="handleTablePhone" width="250">
				<template slot-scope="scope">
					{{ scope.row.phone_number | formatPhone }} <el-tag size="mini" v-if="scope.row.crm_contact_id">from CRM</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="note" :label="$t('customerPhone.remarkName')" width="200"></el-table-column>
			<!-- 隐藏2.8版本暂时不上线功能  -->
			<!-- <el-table-column prop="position" :label="$t('customerPhone.numberIdentityNote')" width="200"></el-table-column> -->
			<el-table-column prop="comment" :label="$t('customerPhone.memorandum')" width="100"></el-table-column>
			<el-table-column :label="$t('customerPhone.smsDisable')" width="100">
				<template slot-scope="scope">
					<el-checkbox v-model="scope.row.sms_blacklist" @change="handleUpdateSmsBlacklistFeatureActive(scope.row)"> </el-checkbox>
				</template>
			</el-table-column>
			<el-table-column v-for="item in normalFeatures" :label="item.title" :key="item.id" width="120">
				<template slot-scope="scope">
					<el-checkbox-group v-model="scope.row.selectedFeatures">
						<el-checkbox
							:key="item.id"
							:label="item.id"
							:disabled="isCanClickKFOSSTMOrBOLRecord(item)"
							@change="
								($event) => {
									handleIsFeature($event);
									handleSetFeatures(scope.row, item.id, item.alias);
								}
							"
							>{{
						}}</el-checkbox>
					</el-checkbox-group>
				</template>
			</el-table-column>
			<el-table-column v-if="billManagementFeature" :label="billManagementFeature.title" width="200">
				<template slot="header">
					<span>{{ billManagementFeature.title }}</span>
					<el-tag size="mini" class="new-badge">{{ $t("customerPhone.add") }}</el-tag>
				</template>
				<template slot-scope="scope">
					<el-switch v-model="scope.row.bill_management" active-color="#2e7d32" @change="handleBillManagementChange(scope.row)" />
				</template>
			</el-table-column>
			<!-- 隐藏2.8版本暂时不上线功能 width="250" -->
			<el-table-column :label="$t('customerPhone.operate')">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEditDialogForm(scope.$index, scope.row)">{{ $t("customerPhone.edit") }}</el-button>
					<el-button size="mini" type="danger" @click="unbindPhone(scope.$index, phonesData)">{{ $t("customerPhone.unbind") }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 添加绑定弹出框 -->
		<section>
			<el-dialog :title="$t('customerPhone.addBinding')" :visible.sync="addDialogFormVisible" width="30%" :close-on-click-modal="false">
				<el-form ref="addDialogForm" :rules="formRules" :model="addDialogForm">
					<el-form-item :label="$t('customerPhone.telephoneNumber')" prop="phone_number">
						<el-select
							v-model.number="addDialogForm.phone_number"
							:placeholder="$t('customerPhone.CRMContact')"
							@change="handleInputNumber"
							style="width: 100%"
						>
							<el-option
								v-for="item in customerCRMPhones"
								:key="item.id"
								:label="`${item.name} (${item.identity}) ${item.phone}`"
								:value="item.phone"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('customerPhone.memorandum')" prop="comment">
						<el-input v-model="addDialogForm.comment" :maxlength="200" :placeholder="$t('customerPhone.enterANote')"></el-input>
					</el-form-item>
					<!-- 隐藏2.8版本暂时不上线功能  -->
					<!-- <el-form-item :label="$t('customerPhone.numberIdentityNote')" prop="position">
						<el-select
							:placeholder="$t('customerPhone.selectIdentityNote')"
							style="width: 100%"
							@change="handleAddSelectPhoneRemark"
							v-model="addDialogForm.position"
						>
							<el-option v-for="(item, index) in customerPhoneRemark" :key="index" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item> -->
				</el-form>

				<span slot="footer" class="dialog-footer">
					<el-button @click="customerBindCancel()">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="bindPhone()">{{ $t("common.confirm") }}</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="$t('customerPhone.customRemarks')" :visible.sync="isAddCustomVisible" width="30%" :close-on-click-modal="false">
				<el-input v-model="addDialogForm.position" :placeholder="$t('customerPhone.pleaseEnterCustomRemarks')"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="handleCustomCancel()">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="handleCustomSubmit()">{{ $t("common.confirm") }}</el-button>
				</span>
			</el-dialog>
		</section>

		<!-- 编辑绑定 -->
		<section>
			<el-dialog :title="$t('customerPhone.editBinding')" :visible.sync="editDialogFormVisible" width="30%" :close-on-click-modal="false">
				<el-form ref="editDialogForm" :rules="formRules" :model="editDialogForm">
					<el-form-item :label="$t('customerPhone.telephoneNumber')" prop="phone_number">
						<el-input v-model="editDialogForm.phone_number" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item :label="this.$t('customerPhone.memorandum')" prop="comment">
						<el-input v-model="editDialogForm.comment"></el-input>
					</el-form-item>
					<!-- 隐藏2.8版本暂时不上线功能  -->
					<!-- <el-form-item :label="$t('customerPhone.numberIdentityNote')" prop="position">
						<el-select
							:placeholder="$t('customerPhone.selectIdentityNote')"
							style="width: 100%"
							@change="handleSelectPhoneRemark"
							v-model="editDialogForm.position"
						>
							<el-option v-for="(item, index) in customerPhoneRemark" :key="index" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item> -->
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="handleEditCancel()">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="handleEditSubmit()">{{ $t("common.confirm") }}</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="$t('customerPhone.customRemarks')" :visible.sync="isCustomVisible" width="30%" :close-on-click-modal="false">
				<el-input v-model="editDialogForm.position" :placeholder="$t('customerPhone.pleaseEnterCustomRemarks')"></el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="handleCustomCancel()">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="handleCustomSubmit()">{{ $t("common.confirm") }}</el-button>
				</span>
			</el-dialog>
		</section>
	</div>
</template>

<script>
import {
	getCustomersPhones,
	bindPhone,
	unbindPhone,
	editPhone,
	getFeatures,
	postUpdateFeatureActive,
	postUpdateSmsBlacklistFeatureActive,
	getCustomersCRMPhones,
	getCustomersDetails,
} from "@/services/api-v2/api-v2";

import { formatPhone, trimPhone } from "@/utils/string";

import i18n from "@/i18n/config";

// 账单管理功能 alias（features 接口返回的标识字段）
const BILL_MANAGEMENT_ALIAS = "BILL_MANAGEMENT";

export default {
	name: "customerPhone",
	data() {
		return {
			// 加载动画
			loading: false,

			// 客户id
			customerId: "",

			// 客户绑定的数据
			phonesData: [],

			// 添加绑定弹出框
			addDialogFormVisible: false,

			// 客户绑定表单值
			addDialogForm: {
				phone_number: "",
				comment: "",
				position: "",
			},

			// 客户添加绑定时号码身份备注自定义开关
			isAddCustomVisible: false,

			// 客户编辑表单窗口显示设置
			editDialogFormVisible: false,

			// 客户编辑时表单值
			editDialogForm: {
				customer_id: "",
				phone_number: "",
				comment: "",
				position: "",
			},

			// 表单验证
			formRules: {
				phone_number: [{ required: true, min: 14, message: this.$t("customerPhone.correctPhoneNumber"), trigger: "blur" }],
				comment: [{ required: true, max: 200, message: this.$t("customerPhone.ContentIsTooLong"), trigger: "blur" }],
			},

			// 权限设置列表
			features: [],

			// 是否设置权限开关
			isActivated: false,

			// 客户CRM电话列表
			customerCRMPhones: [],

			// 客户号码身份备注选项列表
			customerPhoneRemark: [
				{
					value: this.$t("customerPhone.manager"),
					label: this.$t("customerPhone.manager"),
				},
				{
					value: this.$t("customerPhone.boss"),
					label: this.$t("customerPhone.boss"),
				},
				{
					value: this.$t("customerPhone.headChef"),
					label: this.$t("customerPhone.headChef"),
				},
				{
					value: this.$t("customerPhone.accountant"),
					label: this.$t("customerPhone.accountant"),
				},
				{
					value: this.$t("customerPhone.custom"),
					label: this.$t("customerPhone.custom"),
				},
			],

			// 客户号码身份备注自定义开关
			isCustomVisible: false,
			permissionStrategy: {
				STM: (type) => type.is_kf || type.is_os,
				BOL_RECORD: (type) => type.is_sj,
			},
			customerType: {
				is_sj: false,
				is_kf: false,
				is_os: false,
			},
		};
	},

	created() {
		this.customerId = this.$route.params.id;
		this.initCustomersPhones();
		i18n.on("languageChanged", (newLocale) => {
			// 当语言变化时执行的操作
			console.log("语言变化了");
			// 执行其他操作或更新组件内容
		});
	},

	methods: {
		// 初始化数据
		async initCustomersPhones() {
			this.loading = true;
			try {
				const { data: customerData } = await getCustomersDetails(this.customerId);
				console.log(customerData);

				this.customerType = customerData;
				const { data } = await getCustomersPhones(this.customerId);
				this.phonesData = data.map((item) => ({
					...item,
					selectedFeatures: item.features.filter((value) => value.activated).map((value) => value.id),
					// 账单管理勾选逻辑与其他功能一致：取该号码 features 里 BILL_MANAGEMENT 的 activated
					bill_management: item.features.some((value) => value.alias === BILL_MANAGEMENT_ALIAS && value.activated),
				}));
				this.permissionList();
				const CRMPhones = await getCustomersCRMPhones(this.customerId);
				this.customerCRMPhones = CRMPhones.data;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 获取权限列表
		async permissionList() {
			try {
				const features = await getFeatures(this.$i18n.locale);
				this.features = features.data;
			} catch (error) {
				this.$message.error(error);
			}
		},

		// 点击添加绑定
		async handleBindPhone() {
			this.addDialogFormVisible = true;
		},

		// 确定添加绑定
		bindPhone() {
			this.$refs.addDialogForm.validate(async (valid) => {
				if (valid) {
					const phoneNumber = trimPhone(this.addDialogForm.phone_number);
					try {
						await bindPhone(this.customerId, phoneNumber, this.addDialogForm.comment, this.addDialogForm.position);
						this.initCustomersPhones();
						this.$message.success(this.$t("customerPhone.bindingSuccessfully"));
						this.$refs.addDialogForm.resetFields(); // 重置表单
						this.addDialogFormVisible = false; // 关闭表单
					} catch (error) {
						this.$message.error(error);
					}
				} else {
					this.$message.error(this.$t("customerPhone.errorMessage")); // 弹出错误提示
					return false;
				}
			});
		},

		// 添加号码时选择号码身份备注
		handleAddSelectPhoneRemark(value) {
			if (value === this.$t("customerPhone.custom")) {
				this.addDialogForm.position = "";
				this.isAddCustomVisible = true;
				return;
			}
			this.addDialogForm.position = value;
		},

		// 取消绑定
		customerBindCancel() {
			this.$refs.addDialogForm.resetFields(); // 重置表单
			this.addDialogFormVisible = false; // 关闭客户表单窗口
		},

		//点击编辑
		handleEditDialogForm(index, row) {
			if (row.crm_contact_id) {
				this.$message.info(this.$t("customerPhone.phoneEditDelateGuid"));
				return;
			}

			this.editDialogForm.phone_number = formatPhone(row.phone_number);
			this.editDialogForm.comment = row.comment;
			this.editDialogForm.position = row.position;
			this.editDialogForm.customer_index = index;
			this.editDialogFormVisible = true;
		},

		// 取消编辑
		handleEditCancel() {
			this.editDialogFormVisible = false;
		},

		//确定编辑
		async handleEditSubmit() {
			this.$refs.editDialogForm.validate(async (valid) => {
				if (valid) {
					const phoneNumber = trimPhone(this.editDialogForm.phone_number);
					try {
						await editPhone(this.customerId, phoneNumber, this.editDialogForm.comment, this.editDialogForm.position);
						this.phonesData[this.editDialogForm.customer_index].comment = this.editDialogForm.comment;
						this.phonesData[this.editDialogForm.customer_index].position = this.editDialogForm.position;
						this.handleEditCancel();
						this.$message.success(this.$t("customerPhone.successfulOperation"));
					} catch (error) {
						this.$message.error(error); // 弹出错误提示
						return false;
					}
				} else {
					this.$message.error(this.$t("customerPhone.errorMessage")); // 弹出错误提示
					return false;
				}
			});
		},

		// 是否设置权限开关
		handleIsFeature(e) {
			this.isActivated = e;
		},

		// 设置权限
		async handleSetFeatures(row, featureId) {
			this.loading = true;
			try {
				await postUpdateFeatureActive(this.customerId, row.phone_number, featureId, this.isActivated ? 1 : 0);
				this.$message.success(this.$t("customerPhone.setupSuccessful"));
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		async handleUpdateSmsBlacklistFeatureActive(row) {
			this.loading = true;
			try {
				//TODO:: 禁用客人sms黑名单 特殊处理
				await postUpdateSmsBlacklistFeatureActive(this.customerId, row.phone_number, row.sms_blacklist ? 1 : 0);
				this.$message.success(this.$t("customerPhone.setupSuccessful"));
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 账单管理开关
		async handleBillManagementChange(row) {
			this.loading = true;
			try {
				await postUpdateFeatureActive(this.customerId, row.phone_number, this.billManagementFeature.id, row.bill_management ? 1 : 0);
				this.$message.success(this.$t("customerPhone.setupSuccessful"));
			} catch (error) {
				row.bill_management = !row.bill_management;
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 客户电话号码解除绑定
		async unbindPhone(index, rows) {
			if (rows[index].crm_contact_id) {
				this.$message.info(this.$t("customerPhone.phoneEditDelateGuid"));
				return;
			}

			const result = await this.$confirm(this.$t("customerPhone.unbindHint"), this.$t("customerPhone.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			});
			if (result == "confirm") {
				try {
					await unbindPhone(this.customerId, rows[index].phone_number);
					rows.splice(index, 1); // 删除解除绑定的行
					this.$message.success(this.$t("customerPhone.UnbindingSuccessful")); // 弹出成功提示
				} catch (error) {
					this.$message.error(error); // 弹出错误提示
				}
			}
		},
		// 输入格式化电话号码
		handleInputNumber(value) {
			const x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
			const phoneNumber = !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
			this.addDialogForm.phone_number = phoneNumber;
		},
		// 格式化电话号码
		handleTablePhone(row) {
			return formatPhone(row.phone_number);
		},
		// 选择号码身份备注
		handleSelectPhoneRemark(value) {
			if (value === this.$t("customerPhone.custom")) {
				this.editDialogForm.position = "";
				this.isCustomVisible = true;
				return;
			}
			this.editDialogForm.position = value;
		},

		// 取消自定义号码身份备注
		handleCustomCancel() {
			this.editDialogForm.position = "";
			this.isCustomVisible = false;
			this.addDialogForm.position = "";
			this.isAddCustomVisible = false;
		},
		// 确定自定义号码身份备注
		handleCustomSubmit() {
			this.isCustomVisible = false;
			this.isAddCustomVisible = false;
		},

		// 显示编辑删除引导
		showPhoneEditDeleteGuide() {
			this.$message.info(this.$t("customerPhone.phoneEditDelateGuid"));
		},
		// 是否可点击KF/OS的STM或者BOL_RECORD
		isCanClickKFOSSTMOrBOLRecord(item) {
			const strategy = this.permissionStrategy[item.alias];
			return strategy ? strategy(this.customerType) : false;
		},
	},

	computed: {
		currentLocale() {
			return i18n.locale;
		},
		// 普通权限功能（排除账单管理，账单管理单独用开关列展示）
		normalFeatures() {
			return this.features.filter((item) => item.alias !== BILL_MANAGEMENT_ALIAS);
		},
		// 账单管理功能项，features 接口返回后才有值，用于控制列显示
		billManagementFeature() {
			return this.features.find((item) => item.alias === BILL_MANAGEMENT_ALIAS) || null;
		},
	},
	watch: {
		currentLocale(newVal, oldVal) {
			this.permissionList();
		},
	},
};
</script>

<style scoped>
.breadcrumb {
	margin-bottom: 20px;
}
.el-table .cell {
	word-break: normal;
}
.new-badge {
	background-color: #2e7d32;
	color: #fff;
	border: none;
	border-radius: 10px;
	padding: 0 10px;
	height: 18px;
	line-height: 18px;
	font-size: 12px;
	font-weight: bold;
	margin-left: 4px;
	vertical-align: middle;
}
</style>
